/* WebComponentBehavior template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { BehaviorComponent } from './cwc-behavior';

/**
 * Definition of  parameters that the template needs to work.
 */
interface BehaviorTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: BehaviorComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const BehaviorTemplate: FunctionalComponent<BehaviorTemplateProps> = () => <Host></Host>;

export default BehaviorTemplate;
